<template>
  <div class="achievement">
    <div class="wrap">
      <div class="wrapTop">
        <span>医院健康信息学平台的最新进展：糖尿病治 疗策略技术评估</span>
      </div>
      <div class="wrapCent">
        <img src="../../assets/images/banner.png"
             alt="">
      </div>
      <div class="wrapMin"
           @click="lookAnswer">
        <span>看解析>></span>
      </div>
      <div class="wrapBnt">
        <span @click="goVideo">返回课程</span>
        <span @click="goAch">领取成就卡</span>
      </div>
    </div>
  </div>
</template>
<script>
import AppSetting from '../../AppSetting';
import loginService from '../../plugin/extendFn/loginService';
import iVideolist from '../container/videoList'
export default {
  data () {
    return {
      activeTab: 1,
      itemId: 1,
      wxuser: null,
      achData: '',
    }
  },
  props: {},
  async mounted () {
    this.wxuser=await loginService.getLoginUser();
    document.title = '课程结业';
    // this.$postHttp(AppSetting.baseUrl + '/student/complete/video',{uid:this.wxuser.uId,}).then((res)=>{
    //   if(res.data.code==0){
    //     this.video_hottest = res.data.list;
    //   }
    // })
    //   this.getList()
  },
  methods: {
    goVideo () {
      this.$router.push({
        name: "Video",
        // query:{type:"live",liveId:id}
      })
    },
    goAch () {
      this.$router.push({
        name: "AchieveCar",
        query: { type: "ccreslut", id: this.$route.query.id }
      })
    },
    lookAnswer () {
      let query = this.$route.query;
      this.$router.push({
        name: "Answer",
        query: { type: "ccreslut", id: query.id }
      })
    },
  },
  components: {

  },
  computed: {},

}
</script>
<style scoped lang="scss">
.achievement {
  width: 100%;
  height: 100%;
  background: #f4f5f4;
  min-height: 100vh;
  .wrap {
    padding: 0px 0.4rem;
    box-sizing: border-box;
  }
  .wrapTop {
    font-size: 0.34rem;
    color: #333;
    text-align: center;
    margin-top: 1rem;
  }
  .wrapCent {
    width: 100%;
    height: 2.3rem;
    background: blue;
    margin-top: 1rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .wrapMin {
    text-align: right;
    color: #fc8e2a;
    font-size: 0.28rem;
    margin-top: 0.4rem;
  }
  .wrapBnt {
    font-size: 0.36rem;
    text-align: center;
    margin-top: 3rem;
    span {
      border-radius: 0.1rem;
      line-height: 0.9rem;
      width: 45%;
    }
    span:first-child {
      float: left;
      color: #05a2ff;
      border: 0.01rem solid #05a2ff;
    }
    span:last-child {
      float: right;
      color: #fff;
      background: #05a2ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/me/ccreslut.vue